


















import { Component, Prop, Vue } from 'vue-property-decorator'
import questionIcon from '@/assets/img/icon/question.svg'

@Component
export default class InfoPopover extends Vue {
  @Prop({ type: Array, default: () => [] })
  lines!: string[]

  @Prop({ type: String, default: 'left' })
  placement!: string

  @Prop({ type: String, default: 'auto' })
  width!: string

  @Prop({ type: String, default: 'hover' })
  trigger!: string

  @Prop({ type: String, default: 'effective-time-popover' })
  popperClass!: string

  @Prop({ type: String, default: '' })
  iconSrc!: string

  @Prop({
    type: String,
    default: 'margin-left: 5px; cursor: pointer; vertical-align: middle; margin-top: -6px;'
  })
  iconStyle!: string

  get finalIconSrc() {
    return this.iconSrc || questionIcon
  }
}
